"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-btn-group {\n  display: flex; }\n  .bds-btn-group > button:not(:last-child):not(:first-child) {\n    border-radius: 0; }\n  .bds-btn-group > button:first-child {\n    border-radius: 0.1875rem 0 0 0.1875rem; }\n  .bds-btn-group > button:last-child {\n    border-radius: 0 0.1875rem 0.1875rem 0; }\n  .bds-btn-group > div:not(:last-child):not(:first-child) > button {\n    border-radius: 0; }\n  .bds-btn-group > div:first-child > button {\n    border-radius: 0.1875rem 0 0 0.1875rem; }\n  .bds-btn-group > div:last-child > button {\n    border-radius: 0 0.1875rem 0.1875rem 0; }\n";
  var fileName = "compone_buttonGroup";
  var element = document.querySelector("style[data-sass-component='compone_buttonGroup']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      type = _ref.type,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _constants.defaultSize : _ref$size,
      defaultValue = _ref.defaultValue;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useEffect)(function () {
    if (defaultValue) {
      setSelected(defaultValue);
    } // Not passing any dependencies because it needs to execute once after mounting.

  }, []);

  var btnGroupParentClass = _defineProperty({}, _constants.classes.buttonGroup, true);

  var isRadioType = type === "radio";

  var handleClick = function handleClick(event) {
    var value = event.currentTarget.value;
    setSelected(value);
    onClick && onClick(value);
  };

  var getButtonVariant = function getButtonVariant(value, index) {
    if (!selected) {
      return index === 0 ? 'primary' : 'secondary';
    } else {
      return selected === value ? 'primary' : 'secondary';
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "button-group",
    className: (0, _classnames.default)(_objectSpread({}, btnGroupParentClass))
  }, _react.default.Children.map(children, function (child, index) {
    if ( /*#__PURE__*/_react.default.isValidElement(child)) {
      var newProps = {
        key: "".concat(index, "-").concat(child.props.value),
        size: size
      };

      if (isRadioType) {
        newProps = _objectSpread(_objectSpread({}, newProps), {}, {
          onClick: handleClick,
          variant: getButtonVariant(child.props.value, index)
        });
      }

      return /*#__PURE__*/_react.default.cloneElement(child, newProps);
    }

    return null;
  }));
};

ButtonGroup.propTypes = {
  children: _propTypes.default.node.isRequired,
  type: _propTypes.default.string,
  onClick: _propTypes.default.func,
  size: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
var _default = ButtonGroup;
exports.default = _default;